import { ROUTES } from '../../../constants/routes'

export function loginRoute() {
  return ROUTES.login
}
